import {filterByCode} from './filterByCode';
import {findProductComponent} from './findProductComponent';

export default {
    filterByCode,
    findProductComponent
}